const desktopNav = document.querySelector('desktop-navigation');
const desktopFirstLevelLinks = desktopNav.querySelectorAll('.header__linklist-link');
const desktopSecondLevelLinks = desktopNav.querySelectorAll('.mega-menu__title');
const desktopThirdLevelLinks = desktopNav.querySelectorAll('.linklist__item');
const desktopMegaMenuHeadings = desktopNav.querySelectorAll('.mega-menu__heading');
const mobileNav = document.querySelector('mobile-navigation');
const mobileLinks = mobileNav.querySelectorAll('.mobile-nav__link');
const mobileMegaMenuHeadings = mobileNav.querySelectorAll('.mobile-nav__image-heading');
const updateLinkContent = (link) => {
    const innerHTML = link.innerHTML;
    const matches = innerHTML.match(/\[(.*?)\]/);
    if (matches) {
        const string = innerHTML.replace(/\[(.*?)\]/, '');
        const badge = '<span class="sticker">' + matches[1] + '</span>';
        link.innerHTML = string + badge;
    }
};
desktopFirstLevelLinks.forEach((link) => {
    updateLinkContent(link);
});
desktopSecondLevelLinks.forEach((link) => {
    updateLinkContent(link);
});
desktopThirdLevelLinks.forEach((link) => {
    const innerLink = link.querySelector('a');
    updateLinkContent(innerLink);
});
desktopMegaMenuHeadings.forEach((heading) => {
    updateLinkContent(heading);
});
mobileLinks.forEach((link) => {
    updateLinkContent(link);
});
mobileMegaMenuHeadings.forEach((heading) => {
    updateLinkContent(heading);
});
